import { TestosteroneStep } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";

export const getTestosteroneSteps = async () => {
  const response = await privateAPI.get("/user/testosterone-therapy-journey");

  return parseResponseData(response, TestosteroneStep.array());
};
